import script from "./choose.vue?vue&type=script&setup=true&lang=js"
export * from "./choose.vue?vue&type=script&setup=true&lang=js"

import "./choose.vue?vue&type=style&index=0&id=556414d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556414d0"]])

export default __exports__